<header class="page-header">
    <div>
        <h1 class="page-header__title">{{ 'authentication.forgotPassword.title' | translate }}</h1>
        <p class="page-header__description">{{ 'authentication.forgotPassword.description' | translate }}</p>
    </div>
</header>
<form class="form-grid" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-field">
        <label for="forgot-email" class="form-field__label form-field__label--required">{{
            'authentication.forgotPassword.form.email' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-alternate_email" />
            <input
                id="forgot-email"
                [placeholder]="'authentication.common.placeholder.email' | translate"
                type="text"
                formControlName="email"
                autocomplete="off"
                pInputText
                [fluid]="true" />
        </p-iconfield>
        @if (f.email.touched && f.email.errors?.required) {
            <small class="p-error">{{ 'authentication.forgotPassword.validation.requiredEmail' | translate }}</small>
        }
        @if (f.email.touched && f.email.errors?.email) {
            <small class="p-error">{{ 'authentication.forgotPassword.validation.invalidEmail' | translate }}</small>
        }
    </div>
    <p-button
        type="submit"
        [loading]="loading"
        [label]="'authentication.forgotPassword.form.button' | translate"
        [fluid]="true" />
</form>
<a routerLink="/auth/login" class="auth-back text-color-secondary text-sm">
    <span class="material-symbols-outlined icon-sm" aria-hidden="true">chevron_left</span>
    {{ 'authentication.common.navigationBack' | translate }}
</a>
